'use strict';

var assertUnreachable = require('./assertUnreachable-18645656.js');

function verticalListMarginFromPadding(padding) {
  return padding === "normal" ? 0 : padding === "relaxed" ? 10 : assertUnreachable.assertUnreachable(padding);
}

exports.verticalListMarginFromPadding = verticalListMarginFromPadding;